/** Keep only ASCII digits 0–9 (reject Persian/Arabic letters, spaces, +98, etc.). */
export const formatPhoneInputValue = (v) => String(v ?? '').replace(/[^0-9]/g, '').slice(0, 11);

export const normalizeIranianMobile = (v) => formatPhoneInputValue(v);

export const isValidPhone = (v) => /^09\d{9}$/.test(normalizeIranianMobile(v));

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());

export const phoneError = (v) => {
  const raw = normalizeIranianMobile(v);
  if (!raw) return '';
  return isValidPhone(raw) ? '' : 'شماره موبایل معتبر نیست (مثال: 09123456789)';
};

export const emailError = (v) => (String(v || '').trim() && !isValidEmail(v) ? 'ایمیل معتبر نیست (مثال: user@example.com)' : '');

/** Wrap a controlled input onChange so the field only ever stores English digits. */
export const phoneInputChange = (onChange) => (e) => {
  const next = formatPhoneInputValue(e.target.value);
  onChange({ ...e, target: { ...e.target, value: next } });
};

export const phoneInputPaste = (onChange) => (e) => {
  e.preventDefault();
  const text = e.clipboardData?.getData('text') || '';
  const next = formatPhoneInputValue(text);
  onChange({ ...e, target: { ...e.target, value: next } });
};

/** Optional PBX extension; DB column is SMALLINT (max 32767). */
export const formatInnerPhoneInput = (v) => String(v ?? '').replace(/[^0-9]/g, '').slice(0, 5);

export const innerPhoneError = (v) => {
  const raw = formatInnerPhoneInput(v);
  if (!raw) return '';
  const n = Number(raw);
  if (!Number.isFinite(n) || n > 32767) {
    return 'تلفن داخلی کوتاه باشد (نه شماره موبایل؛ حداکثر ۵ رقم)';
  }
  return '';
};

export const innerPhoneInputChange = (onChange) => (e) => {
  const next = formatInnerPhoneInput(e.target.value);
  onChange({ ...e, target: { ...e.target, value: next } });
};
